import axios from 'axios';
import {
  createAuthRequestInterceptor,
  createRequestErrorInterceptor,
  createResponseSuccessInterceptor,
  createResponseErrorInterceptor,
} from './interceptors';
import { getApiBaseUrl, getFrontstoreApiKey } from '../utils/env';

const API_BASE_URL: string = getApiBaseUrl('/api');

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 0,
  // Required by the backend's FrontstoreKeyGuard on GET /products, which the
  // invoice/order product search hits. axios omits headers whose value is
  // undefined, so an unset key sends nothing rather than "undefined".
  headers: { 'x-frontstore-key': getFrontstoreApiKey() },
  // Sends the httpOnly accessToken/refreshToken cookies automatically.
  withCredentials: true,
  // Our API never redirects; 0 also keeps custom headers (CSRF) out of
  // follow-redirects, which leaks them cross-domain (GHSA-r4q5-vmmm-2653).
  maxRedirects: 0,
});

axiosClient.interceptors.request.use(
  createAuthRequestInterceptor(),
  createRequestErrorInterceptor()
);

axiosClient.interceptors.response.use(
  createResponseSuccessInterceptor(),
  createResponseErrorInterceptor(axiosClient)
);

export default axiosClient;
